export const getItem = key => localStorage.getItem(key);

export const setItem = (key, value) => localStorage.setItem(key, JSON.stringify(value));

export const removeItem = key => localStorage.removeItem(key);

export const AUTHED_USER = "auth";
export const LAST_PARAMS = "lastParams";